import { render, staticRenderFns } from "./NetworkSmall.vue?vue&type=template&id=2d06a03e&scoped=true"
import script from "./NetworkSmall.vue?vue&type=script&lang=js"
export * from "./NetworkSmall.vue?vue&type=script&lang=js"
import style0 from "./NetworkSmall.vue?vue&type=style&index=0&id=2d06a03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06a03e",
  null
  
)

export default component.exports